import {
  Component,
  EventEmitter,
  Output,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {
  toothInputValidator,
  RenderableFindingBase,
} from "@kells/interfaces/finding";
import { observeProperty } from "@kells/utils/angular";
import { SubSink } from "subsink";
import { keepDefined, pipeLog } from "@kells/utils/observable/observable-operators";
import { Observable } from "rxjs";
import { ToothUpdatePayload } from "@kells/shared-ui/canvas";

@Component({
  selector: "canvas-tooth-edit-form",
  templateUrl: "./tooth-edit-form.component.html",
  styleUrls: ["./tooth-edit-form.component.scss"],
})
export class ToothEditFormComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() initialData:
    | (RenderableFindingBase & { id: number })
    | undefined = undefined;
  private initialData$: Observable<
    (RenderableFindingBase & { id: number }) | undefined
  > = observeProperty(this, "initialData");

  @Input() showDeletButton: boolean;


  @Input('imageConfirmed') isImageConfirmed = false;
  isImageConfirmed$: Observable<boolean> = observeProperty(this, "isImageConfirmed")
    .pipe(pipeLog('isImageConfirmed$'));

  @Output() onSave = new EventEmitter<ToothUpdatePayload>();

  @Output() onCancel = new EventEmitter<unknown>();

  @Output() onDelete = new EventEmitter<number>();

  @ViewChild("tooth_field") toothFieldRef: ElementRef<HTMLInputElement>;

  private _subs = new SubSink();

  private _data:RenderableFindingBase;

  ngOnInit() {
    this.initialData$
      .pipe(keepDefined())
      .subscribe(this.populateInitialData.bind(this));
  }

  ngAfterViewInit() {
    this.afterViewInitFocusOnToothField();
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

  editForm = new FormGroup({
    tooth: new FormControl("", [Validators.required, toothInputValidator]),
  });

  get editFormTooth() {
    return this.editForm.get("tooth");
  }

  onSaveClicked() {
    this.onSave.emit({
      tooth: this.editForm.value.tooth
    });
  }

  onCancelClicked() {
    this.editForm.reset();
    this.onCancel.next();
  }


  onDeleteClicked() {
    if (this.initialData) {
      this.onDelete.emit(this.initialData.id);
      this.editForm.reset();
    }
  }

  private populateInitialData(data: RenderableFindingBase) {
    this._data = data;
    this.editForm.setValue({
      tooth: data.tooth ?? "",
    });
  }

  private afterViewInitFocusOnToothField() {
    this.toothFieldRef.nativeElement.focus();
  }
}
